import MetricEventTypes from "@Enums/MetricEventTypes";
import MetricFilterTypes from "@Enums/MetricFilterTypes";
import PlaySessionTypes from "@Enums/PlaySessionTypes";
import UserProgressStats from "@Enums/UserProgressStats";
import { Theme } from "@mui/material";

const getMetricPrimaryColor = (
  metricName: MetricEventTypes | MetricFilterTypes | UserProgressStats | PlaySessionTypes,
  theme: Theme
) => {
  const iconMap = new Map<MetricEventTypes | MetricFilterTypes | UserProgressStats | PlaySessionTypes, string>([
    [MetricEventTypes.SCAN_FREQUENCY, theme.palette.dsPrimary.v300],
    [MetricEventTypes.AWARENESS, theme.palette.dsSecondaryPurple.v300],
    [MetricEventTypes.SCAN_TIMING, theme.palette.dsWarning.v300],
    [MetricEventTypes.CRITICAL_SCAN, theme.palette.dsSuccess.v300],
    [MetricEventTypes.DECISION, theme.palette.dsDestructive.v300],
    [UserProgressStats.WEEKLY_TRAINING, theme.palette.dsWarning.v300],
    [PlaySessionTypes.CHALLENGE_SESSION, theme.palette.dsSecondaryYellow.v400],
  ]);

  return iconMap.get(metricName) || theme.palette.dsPrimary.v300;
};

const getMetricSecondaryColor = (
  metricName: MetricEventTypes | MetricFilterTypes | UserProgressStats | PlaySessionTypes,
  theme: Theme
) => {
  const iconMap = new Map<MetricEventTypes | MetricFilterTypes | UserProgressStats | PlaySessionTypes, string>([
    [MetricEventTypes.SCAN_FREQUENCY, theme.palette.dsPrimary.v100],
    [MetricEventTypes.AWARENESS, theme.palette.dsSecondaryPurple.v100],
    [MetricEventTypes.SCAN_TIMING, theme.palette.dsWarning.v100],
    [MetricEventTypes.CRITICAL_SCAN, theme.palette.dsSuccess.v100],
    [MetricEventTypes.DECISION, theme.palette.dsDestructive.v100],
    [UserProgressStats.WEEKLY_TRAINING, theme.palette.dsWarning.v100],
    [PlaySessionTypes.CHALLENGE_SESSION, theme.palette.dsSecondaryYellow.v200],
  ]);

  return iconMap.get(metricName) || theme.palette.dsPrimary.v200;
};

export { getMetricPrimaryColor, getMetricSecondaryColor };
